import { Link } from 'react-router-dom'
import Header from './Header'
import './LandingPage.css'

const PortfolioPage = () => {
  /* Services dropdown state and effects moved to Header component */

  return (
    <div className="landing-page portfolio-page">
      <Header />

      {/* Portfolio Hero Section */}
      <section className="portfolio-hero-section">
        <div className="portfolio-hero-content">
          <p className="portfolio-hero-script">We've Built Brands That</p>
          <h1 className="portfolio-hero-headline">DON'T BLEND IN — THEY BREAK THROUGH.</h1>
          <p className="portfolio-hero-tagline">From beauty to tech – every identity we craft tells a story, not just a logo.</p>
        </div>
      </section>

      {/* Portfolio Process Banner */}
      <section className="portfolio-process-banner">
        <div className="portfolio-process-banner-wrapper">
          <div className="portfolio-process-glasses">
            <img src="/icons BCS-24.svg" alt="Glasses icon" className="portfolio-process-glasses-icon" />
          </div>
          <div className="portfolio-process-content">
            <div className="portfolio-process-headline-wrapper">
              <h2 className="portfolio-process-headline">FROM IDEA → IDENTITY → IMPACT</h2>
              <div className="portfolio-process-speech">
                <img src="/icons BCS-35.svg" alt="Speech bubble icon" className="portfolio-process-speech-icon" />
              </div>
            </div>
            <p className="portfolio-process-description">A collection of brands built with intention, attitude, and a whole lot of bold energy.</p>
          </div>
        </div>
      </section>

      {/* Portfolio Brands Showcase */}
      <section className="portfolio-brands-section">
        <div className="portfolio-brands-grid">
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-01.png" alt="Boklip" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Boklip</h3>
          </div>
          <div className="portfolio-brand-card portfolio-brand-card-middle">
            <div className="portfolio-brand-images">
              <img src="/Slider images-02.png" alt="Dr. Ayesha Kamal" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Dr. Ayesha Kamal</h3>
          </div>
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-03.png" alt="odorguard" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">odorguard</h3>
          </div>
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-04.png" alt="Neuvian Skincare" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Neuvian Skincare</h3>
          </div>
          <div className="portfolio-brand-card portfolio-brand-card-middle">
            <div className="portfolio-brand-images">
              <img src="/Slider images-05.png" alt="Zoubeir Technologies" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Zoubeir Technologies</h3>
          </div>
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-06.png" alt="Ziaha Kombucha" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Ziaha Kombucha</h3>
          </div>
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-07.png" alt="Golfymix" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Golfymix</h3>
          </div>
          <div className="portfolio-brand-card portfolio-brand-card-middle">
            <div className="portfolio-brand-images">
              <img src="/Slider images-08.png" alt="DevDash Technologies" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">DevDash Technologies</h3>
          </div>
          <div className="portfolio-brand-card">
            <div className="portfolio-brand-images">
              <img src="/Slider images-09.png" alt="Viva Alliance" className="portfolio-brand-image" />
            </div>
            <h3 className="portfolio-brand-name">Viva Alliance</h3>
          </div>
        </div>
      </section>

      {/* Bold Ideas Banner Section */}
      <section className="bold-ideas-banner-section">
        <div className="bold-ideas-banner-icon">
          <img src="/icons BCS-25.svg" alt="Megaphone icon" className="bold-ideas-megaphone-icon" />
        </div>
        <div className="bold-ideas-banner-container">
          <div className="bold-ideas-banner-track">
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            {/* Duplicate items for seamless loop */}
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
            <div className="bold-ideas-banner-item">
              <img src="/submark%20socials@4x.png" alt="Bold Ideas Logo" className="bold-ideas-logo" />
              <p className="bold-ideas-text">Turning Bold Ideas Into Reality</p>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio CTA Section */}
      <section className="portfolio-cta-section">
        <div className="portfolio-cta-star-top-left">
          <img src="/icons BCS-22.svg" alt="Star icon" className="portfolio-cta-star-icon" />
        </div>
        <div className="portfolio-cta-content">
          <h2 className="portfolio-cta-headline">
            READY TO BRING YOUR <span className="portfolio-cta-bold">BOLD BRAND</span> UP HERE NEXT?
          </h2>
          <p className="portfolio-cta-description">
            If you're bringing something bold to life and want branding that keeps up, we'd love to help.
          </p>
          <Link to="/contact" className="portfolio-cta-button">Let's Do This</Link>
        </div>
        <div className="portfolio-cta-star-bottom-right">
          <img src="/icons BCS-22.svg" alt="Star icon" className="portfolio-cta-star-icon" />
        </div>
      </section>
      {/* Wave Transition to Footer */}
      <div className="section-divider-wavy footer-divider">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none" className="wavy-svg wavy-green-2">
          <path d="M0,50 Q60,20 120,50 T240,50 T360,50 T480,50 T600,50 T720,50 T840,50 T960,50 T1080,50 T1200,50 T1320,50 T1440,50 L1440,100 L0,100 Z" fill="#CDD951" />
        </svg>
      </div>

      <footer className="main-footer">
        <div className="footer-star-icon">
          <img src="/icons BCS-44.svg" alt="Star icon" className="footer-star-icon-img" />
        </div>
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/BCS%20LOGO-01%20(1).png" alt="BOLD! CREATIVE STUDIO" className="footer-logo-img" />
          </div>
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
              <img src="/WEBSITE IMAGES-17.svg" alt="Instagram" className="footer-social-icon-img" />
            </a>
            <a href="https://www.behance.net/brandingoutloud?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnHFYMm_3Cc_qOoIHo5M7pIpJVh1fw7yG_MjUWcetV-lC7sxbyqLSp49vJ22Y_aem_NaED6HYtWH8rqyuMagDYig" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Behance">
              <img src="/WEBSITE IMAGES-18.svg" alt="Behance" className="footer-social-icon-img" />
            </a>
            <a href="https://www.linkedin.com/company/brandingoutloud/" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
              <div className="footer-social-icon-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#594F9A', borderRadius: '50%', transform: 'scale(0.75)' }}>
                <svg viewBox="0 0 24 24" fill="white" style={{ width: '24px', height: '24px', margin: 0 }}>
                  <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                </svg>
              </div>
            </a>
            <a href="https://www.facebook.com/share/1879QvWrk8/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
              <img src="/WEBSITE IMAGES-19.svg" alt="Facebook" className="footer-social-icon-img" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PortfolioPage

